import { render, staticRenderFns } from "./BeastSearchBox.vue?vue&type=template&id=4d2c2394&scoped=true"
import script from "./BeastSearchBox.vue?vue&type=script&lang=js"
export * from "./BeastSearchBox.vue?vue&type=script&lang=js"
import style0 from "./BeastSearchBox.vue?vue&type=style&index=0&id=4d2c2394&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c2394",
  null
  
)

export default component.exports